import React from 'react';
import { Quote, Star } from 'lucide-react';
import { REVIEWS } from '../mock';

const STAR_KEYS = ['star-1', 'star-2', 'star-3', 'star-4', 'star-5'];

const Reviews = () => (
  <section id="reviews" className="bg-app py-24 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <span className="text-xs tracking-[0.3em] text-sky-400 uppercase font-semibold">Reviews</span>
      <h2 className="mt-3 font-cond font-700 text-4xl md:text-5xl text-white">What Customers Say</h2>

      <div className="mt-12 columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
        {REVIEWS.map((r) => (
          <div key={r.id} className="card-dark rounded-xl p-6 mb-5 break-inside-avoid">
            <div className="flex items-center justify-between">
              <Quote className="w-7 h-7 text-sky-500/40" />
              <span className="flex items-center gap-0.5">
                {STAR_KEYS.map((k) => (
                  <Star key={`${r.id}-${k}`} className="w-3.5 h-3.5 fill-sky-400 text-sky-400" />
                ))}
              </span>
            </div>
            <p className="mt-4 text-gray-300 text-[15px] leading-relaxed">{r.text}</p>
            <p className="mt-4 font-cond font-600 text-sm tracking-wider text-white">— {r.name}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Reviews;
